const state = {
  isOnline: false
};

const getters = {};

const actions = {
  setStateNetwork(context, status) {
    context.commit("setState", status);
  }
};

const mutations = {
  setState(state, status) {
    state.isOnline = status;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
